import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

/**
 * @class Role
 * @property {integer} id
 * @property {string} name
 * @property {string} description
 * @property {integer} status
 */
export class Role extends TranslatableModel {

    static get translatableAttributes() {
        
        return [ 'name', 'description' ];
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'ROLE_NAME_IN_ENGLISH',
                commonLabel: 'Role name'
            },
            name_ar: {
                label: 'ROLE_NAME_IN_ARABIC',
                commonLabel: 'Role name'
            },
            description: {
                label: 'DESCRIPTION_IN_ENGLISH',
                commonLabel: 'Description'
            },
            description_ar: {
                label: 'DESCRIPTION_IN_ARABIC',
                commonLabel: 'Description'
            }
        };
    }
    
    getPermissions(value) {
        
        return angular.isUndefined(value) ? [] : value;
    }
}

AccessorsMutatorsDecorator('id', ...Role.translatableAttributesWithLanguageAliases, 'status', 'property', 'permissions', 'users', 'property_id')(Role);


// WEBPACK FOOTER //
// ./src/pms-api/models/role.model.js